import { render, staticRenderFns } from "./IdentityForm.vue?vue&type=template&id=47ad583d"
import script from "./IdentityForm.vue?vue&type=script&lang=js"
export * from "./IdentityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports